import Typography from "components/commercetools-ui/atoms/typography";
import Markdown from 'components/commercetools-ui/atoms/markdown';
import useMediaQuery from "helpers/hooks/useMediaQuery";
import { desktop, largeDesktop, mediumDesktop, semiLargeDesktop, smallMobile, tablet } from "helpers/utils/screensizes";
 


export type CollectionProps = {
    props?: any;
   
};
const CollectionCards = ({ props }: React.PropsWithChildren<CollectionProps>) => {
    const [isTabletSize] = useMediaQuery(tablet);
    const [isDesktopSize] = useMediaQuery(desktop);
    const [isMobileSize] = useMediaQuery(smallMobile);

    return (
        <div className="bg-[#F8F8F8]">
            {props?.section_with_cards && (
            <div className={`flex justify-evenly 2xl:gap-47 xl:gap-47 md:gap-20 gap-30 md:px-90 px-16 py-64 2xl:px-208 2xl:py-80 text-center ${isDesktopSize? 'flex-row' : 'flex-col'}`}>
                <div className={`2xl:w-[30%] middleresolution:w-[30%] lg:w-[40%] xl:w-[30%] ${isDesktopSize ? 'flex-col' : 'flex flex-row'}`}>
                    <img className="block lg:m-auto w-120  md:w-180" src={props?.section_with_cards[0]?.image?.url} />
                    {isDesktopSize ? (
                        <>
                            {props?.section_with_cards[0]?.title && (
                                <Typography
                                    as="h3"
                                    className="text-20 font-bold leading-10 text-primary-black md:text-0 lg:text-20 xl:text-20 2xl:text-22"
                                >
                                    {props?.section_with_cards[0]?.title}
                                </Typography>
                            )}

                            {props?.section_with_cards[0]?.description && (
                                <Markdown
                                    className="leading-[1.5rem] font-normal  md:text-14 text-primary-black text-16 "
                                >
                                    {props?.section_with_cards[0]?.description}
                                </Markdown>
                            )}
                        </>
                        ) : (
                            <Typography
                                as="h3"
                                className="text-20 block m-auto font-bold leading-10 text-primary-black md:text-30 lg:leading-[3.5rem] 2xl:text-22"
                            >
                                {props?.section_with_cards[0]?.title}
                            </Typography>
                        )}
                    
                </div>
                <div className={` 2xl:w-[30%] middleresolution:w-[30%] lg:w-[40%] xl:w-[30%] ${isDesktopSize? 'flex-col' : 'flex flex-row'}`}>
                    <img className="block lg:m-auto w-120 md:w-180" src={props?.section_with_cards[1]?.image?.url} />
                    {isDesktopSize ? (
                        <>
                            {props?.section_with_cards[1]?.title && (
                                <Typography
                                    as="h3"
                                    className="text-20 font-bold leading-10 text-primary-black md:text-20 lg:text-20 xl:text-20 2xl:text-22"
                                >
                                    {props?.section_with_cards[1]?.title}
                                </Typography>
                            )}

                            {props?.section_with_cards[1]?.description && (
                                <Markdown
                                    className="leading-[1.5rem] font-normal md:text-14 text-primary-black text-16 "
                                >
                                    {props?.section_with_cards[1]?.description}
                                </Markdown>
                            )}
                        </>
                        ) : (
                            <Typography
                                as="h3"
                                className="text-20 block m-auto font-bold leading-10 text-primary-black md:text-30 lg:leading-[3.5rem] 2xl:text-22"
                            >
                                {props?.section_with_cards[1]?.title}
                            </Typography>
                        )}
                </div>
                

                <div className={`2xl:w-[30%] middleresolution:w-[30%] lg:w-[40%] xl:w-[30%] ${isDesktopSize? 'flex-col' : 'flex flex-row'}`}>
                <img className="block lg:m-auto w-120 md:w-180" src={props?.section_with_cards[2]?.image?.url} />
                    {isDesktopSize ? (
                        <>
                            {props?.section_with_cards[2]?.title && (
                                <Typography
                                    as="h3"
                                    className="text-20 block m-auto font-bold leading-10 text-primary-black md:text-30 lg:text-20 xl:text-20 2xl:text-22"
                                >
                                    {props?.section_with_cards[2]?.title}
                                </Typography>
                            )}

                            {props?.section_with_cards[1]?.description && (
                                <Markdown
                                    className="leading-[1.5rem] font-normal md:text-14 text-primary-black text-16 "
                                >
                                    {props?.section_with_cards[2]?.description}
                                </Markdown>
                            )}
                        </>
                        ) : (
                            <Typography
                                as="h3"
                                className="text-20 block m-auto font-bold leading-10 text-primary-black md:text-30 lg:leading-[3.5rem] 2xl:text-22"
                            >
                                {props?.section_with_cards[2]?.title}
                            </Typography>
                        )}
                  
                  </div>

              </div>
          )}
        </div>
    )
} 


export default CollectionCards;